import type { CSSObject } from '@emotion/react'
import { Color, Typography, Theme } from '@opallabs/gem'
import { TextColor } from '../types'

export const styles = (theme: Theme, color: TextColor): CSSObject => ({
  color: color ? Color[theme].Text[color] : Color[theme].Text.Default,
  ...Typography.T300,
})
